import { plainToInstance } from 'class-transformer'
import { FilterBase } from '@core/entities/filters/FilterBase'
import { TaskFilterOperatorTypes } from '../types'
import { ITaskFilter } from './ITaskFilter'
import { TaskStatus } from '@core/entities/task/TaskBase/types'

export class TaskFilter extends FilterBase<ITaskFilter> {
  propertyType: 'TASK'
  operator: TaskFilterOperatorTypes
  taskId: number
  statuses?: Array<TaskStatus>
  numberOfDays?: number

  public static new(payload: unknown): TaskFilter {
    return plainToInstance(TaskFilter, payload)
  }
}
